import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const STORAGE_KEY = 'hp-theme';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private _isDark$ = new BehaviorSubject<boolean>(false);
  readonly isDark$ = this._isDark$.asObservable();

  get isDark(): boolean {
    return this._isDark$.getValue();
  }

  init(): void {
    const stored = localStorage.getItem(STORAGE_KEY);
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const dark = stored === 'dark' || (stored === null && prefersDark);
    this._apply(dark);
  }

  toggle(): void {
    this._apply(!this.isDark);
  }

  setDark(dark: boolean): void {
    this._apply(dark);
  }

  private _apply(dark: boolean): void {
    // Suppress every CSS transition app-wide for one frame so the theme
    // switches everywhere at once, instead of each component's own
    // transition-* classes settling at a different time.
    const suppress = document.createElement('style');
    suppress.textContent = '*, *::before, *::after { transition: none !important; }';
    document.head.appendChild(suppress);

    this._isDark$.next(dark);
    if (dark) {
      document.documentElement.classList.add('dark');
      document.documentElement.classList.remove('light');
    } else {
      document.documentElement.classList.remove('dark');
      document.documentElement.classList.add('light');
    }
    localStorage.setItem(STORAGE_KEY, dark ? 'dark' : 'light');

    requestAnimationFrame(() => {
      requestAnimationFrame(() => suppress.remove());
    });
  }
}
